export default "__VITE_ASSET__C8DEW2XO__"